import { render, staticRenderFns } from "./KpiSide.vue?vue&type=template&id=636ce76a&scoped=true&"
import script from "./KpiSide.vue?vue&type=script&lang=js&"
export * from "./KpiSide.vue?vue&type=script&lang=js&"
import style0 from "./KpiSide.vue?vue&type=style&index=0&id=636ce76a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636ce76a",
  null
  
)

export default component.exports